<div class="bg-beige">
  <app-notification-banner></app-notification-banner>

  <div
    class="hub-main be-container be-container--xl be-container--py"
    *ngIf="(offers$ | async)?.length > 0; else noOffers"
  >
    <h2 class="be-layout-title mb-5 text-navy-900">
      Welcome, {{ firstName$ | async | titlecase }}!
    </h2>
    <div class="hub-main__content">
      <div class="left">
        <div class="accounts">
          <app-accounts-v2
            [accounts]="accounts$ | async"
            [paperlessProfiles]="paperlessProfiles$ | async"
          ></app-accounts-v2>
        </div>

        <div class="mobile_offers" *ngIf="isMobile">
          @if (!isStickyOfferBannerEnabled$ | async) {
            <h2 class="section-title">You're eligible</h2>
          }
          <app-offers-carousel
            [offers]="offers$ | async"
            siteSection="hub"
            [cid]="cid"
            class="offers-override"
            [isStickyOfferBannerEnabled]="isStickyOfferBannerEnabled$ | async"
            (closeBanner)="onCloseOfferClick($event)"
            (learnMore)="openSlideOut($event)"
            [isRefiOfferFirst]="isRefiFirstInCarouselEnabled()"
          >
            <ng-template #slideTemplate let-offer>
              <app-offers-card
                [offer]="offer"
                [isInCarousel]="true"
              ></app-offers-card>
            </ng-template>
          </app-offers-carousel>
        </div>
        <div
          *ngIf="
            isMobile && (displayMobileCard() || isDebtConsolidationEnabled())
          "
        >
          <h2 class="section-title be-section-mt-hub be-section-mb-hub">
            Highlights
          </h2>
          <app-debt-consolidation-placement
            [befhUrl]="(accounts$ | async)?.bechAccounts[0].url"
          ></app-debt-consolidation-placement>
          <app-mobile-app-card
            *ngIf="displayMobileCard()"
          ></app-mobile-app-card>
        </div>
        <div class="credit-health">
          <app-credit-health></app-credit-health>
        </div>
      </div>
      <div class="desktop_offers">
        <h2 class="section-title mb-5">You're eligible</h2>
        <app-offers-carousel
          *ngIf="(offers$ | async)?.length > 0 && !isMobile"
          [offers]="offers$ | async"
          siteSection="hub"
          [cid]="cid"
          class="offers-override"
          [isStickyOfferBannerEnabled]="isStickyOfferBannerEnabled$ | async"
          (learnMore)="openSlideOut($event)"
          [isRefiOfferFirst]="isRefiFirstInCarouselEnabled()"
        >
          <ng-template #slideTemplate let-offer>
            <app-offers-card
              [offer]="offer"
              [isInCarousel]="true"
            ></app-offers-card>
          </ng-template>
        </app-offers-carousel>

        <div
          *ngIf="
            !isMobile && (displayMobileCard() || isDebtConsolidationEnabled())
          "
        >
          <h2 class="section-title be-section-mt-hub be-section-mb-hub">
            Highlights
          </h2>
          <app-debt-consolidation-placement
            [befhUrl]="(accounts$ | async)?.bechAccounts[0].url"
          ></app-debt-consolidation-placement>
          <app-mobile-app-card
            *ngIf="displayMobileCard()"
          ></app-mobile-app-card>
        </div>
      </div>
    </div>
  </div>

  <ng-template #noOffers>
    <div class="hub-main be-container be-container--xl">
      <div class="hub-main__content hub-main__content--no-offers">
        <div class="left">
          <h2 class="greeting">
            Welcome, {{ firstName$ | async | titlecase }}!
          </h2>
          <div class="accounts">
            <app-accounts-v2
              [accounts]="accounts$ | async"
              [paperlessProfiles]="paperlessProfiles$ | async"
            ></app-accounts-v2>
          </div>
          <div
            *ngIf="
              isMobile && (displayMobileCard() || isDebtConsolidationEnabled())
            "
            class="mb-4"
          >
            <h2 class="section-title be-section-mt-hub be-section-mb-hub">
              Highlights
            </h2>
            <app-debt-consolidation-placement
              [befhUrl]="(accounts$ | async)?.bechAccounts[0].url"
            ></app-debt-consolidation-placement>
            <app-mobile-app-card
              *ngIf="displayMobileCard()"
            ></app-mobile-app-card>
          </div>
          <div class="credit-health">
            <app-credit-health></app-credit-health>
          </div>
        </div>
        <div
          *ngIf="
            displayMobileCard() || (isDebtConsolidationEnabled() && !isMobile)
          "
          class="no-offer-app-margin"
        >
          <h2 class="section-title be-section-mt-hub be-section-mb-hub">
            Highlights
          </h2>
          <app-debt-consolidation-placement
            [befhUrl]="(accounts$ | async)?.bechAccounts[0].url"
          ></app-debt-consolidation-placement>
          <app-mobile-app-card
            *ngIf="displayMobileCard()"
          ></app-mobile-app-card>
        </div>
      </div>
    </div>
  </ng-template>
</div>

@if (hasHslOffer()) {
  <app-hsl-slide-out
    [isSlideOutOpen]="isHslSlideOutOpen()"
    [offer]="activeSlideOutOffer()"
  ></app-hsl-slide-out>
}
